<template>
  <div class="admin_home">
    <PayrollHeader />
    <div class="content">
      <div class="payroll__setting">
        <p>hrdesk Setup</p>
        <div>
          <div class="payroll__setting--nav">
            <div class="payroll__setting--nav-first">
              <div>
                <font-awesome-icon icon="check" />
              </div>
              <p>Step 1</p>
            </div>
            <div class="payroll__setting--nav-line"></div>
            <div class="payroll__setting--nav-last">
              <div>
                <font-awesome-icon icon="check" />
              </div>
              <p>Step 2</p>
            </div>
          </div>
        </div>

        <div>
          <div class="payroll__setting--desc">
            <div>
              <img src="./../../../assets/style/images/user.svg" alt="setup" />
            </div>
            <p>Start by setting up your admin account.</p>
          </div>
        </div>

        <div>
          <div class="payroll__setting--container">
            <div>
              <div class="data-fetch-error" v-if="dataFetchError">
                <p>This page did not load successfully. Please try again.</p>
              </div>

              <p>Basic</p>
              <div class="payroll__setting--container-input">
                <div class="payroll__setting--container-input-half">
                  <label>First Name:</label>
                  <input
                    type="text"
                    v-model.trim="newEmployee.firstname"
                    placeholder="First Name"
                  />
                </div>
                <div class="payroll__setting--container-input-half">
                  <label>Last Name:</label>
                  <input
                    type="text"
                    v-model.trim="newEmployee.lastname"
                    placeholder="last name"
                  />
                </div>
                <div class="payroll__setting--container-input-half">
                  <div class="payroll__setting--container-input-small">
                    <div class="payroll__setting--container-input-small-gender">
                      <label>Gender:</label>
                      <select v-model.trim="newEmployee.gender">
                        <option value selected>Gender</option>
                        <option>Female</option>
                        <option>Male</option>
                      </select>
                    </div>

                    <div class="payroll__setting--container-input-small-phone">
                      <label>Phone Number:</label>
                      <input
                        v-model.trim="newEmployee.phone"
                        type="tel"
                        placeholder="+234"
                      />
                    </div>
                  </div>
                </div>
                <div class="payroll__setting--container-input-half">
                  <label>Email Address:</label>
                  <input
                    type="text"
                    v-model.trim="newEmployee.email"
                    placeholder="Email Address"
                    readonly
                  />
                </div>
                <div class="payroll__setting--container-input-half">
                  <label>Home Address:</label>
                  <input
                    type="text"
                    v-model.trim="newEmployee.address"
                    placeholder="Home Address"
                  />
                </div>
                <div class="payroll__setting--container-input-half">
                  <label>Country:</label>
                  <select
                    v-if="country"
                    v-model.trim="newEmployee.country"
                    @change="getState($event)"
                  >
                    <option
                      v-for="countryValue in countryData"
                      :value="countryValue.id"
                      v-bind:key="countryValue.index"
                    >
                      {{ countryValue.name }}
                    </option>
                  </select>
                  <div v-if="!country">
                    <InputLoader />
                  </div>
                </div>
                <div class="payroll__setting--container-input-half">
                  <label>State:</label>
                  <select
                    v-if="state"
                    v-model.trim="newEmployee.state"
                    id="state"
                  >
                    <option
                      v-for="stateValue in stateData"
                      :value="stateValue.id"
                      v-bind:key="stateValue.index"
                    >
                      {{ stateValue.name }}
                    </option>
                  </select>
                  <div v-if="!state">
                    <InputLoader />
                  </div>
                </div>
                <div class="payroll__setting--container-input-half">
                  <label>City</label>
                  <input type="text" v-model.trim="newEmployee.city" />
                </div>
      
                <div class="payroll__setting--container-input-half">
                  <label>Staff ID:</label>
                  <input type="text" v-model.trim="newEmployee.staff_number" />
                  <div v-if="Loader">
                      <InputLoader />
                    </div>
                  <div class="text-align-end" v-if="!Loader">
                    <a
                      class="small"
                      @click.prevent="generateStaffId(newEmployee.email)"
                      href="#"
                      >Generate</a
                    >
                  
                  </div>
                </div>
              </div>

              <div
                class="payroll__setting--container-loader"
                v-if="componentLoader"
              >
                fetching payroll details...wait a minute
              </div>

              <p v-if="!componentLoader">Compensation</p>
              <div
                class="payroll__setting--container-input"
                v-if="!componentLoader"
              >
                <div
                  class="payroll__setting--container-input-amount"
                  v-for="(comp, index) in compensationComponents"
                  :key="index"
                >
                  <label>{{ comp.name }}:</label>
                  <div>
                    <input
                      type="text"
                      @keyup="formatAmount('compensations', comp.name)"
                      v-model.trim="compensation[comp.name]"
                    />
                    <div>&#8358;</div>
                  </div>
                </div>
              </div>

              <p v-if="!componentLoader">Deductibles</p>
              <div
                class="payroll__setting--container-input"
                v-if="!componentLoader"
              >
                <div
                  class="payroll__setting--container-input-amount"
                  v-for="(ded, index) in deductibleComponents"
                  :key="index"
                >
                  <label>{{ ded.name }}:</label>
                  <div>
                    <input
                      type="text"
                      @keyup="formatAmount('deductibles', ded.name)"
                      v-model.trim="deductible[ded.name]"
                    />
                    <div>&#8358;</div>
                  </div>
                </div>
              </div>

              <div class="payroll__setting--container-errors">
                <div v-if="serverErrors">
                  <p v-for="(value, name, index) in serverErrors" :key="index">
                    {{ value[0] }}
                  </p>
                </div>
                <p v-show="emailError">Please enter a valid email address.</p>
                <p v-if="dataSaveError">{{ dataSaveError }}</p>

                <div v-if="emptyFields">
                  <p v-for="(field, index) in emptyFields" :key="index">
                    The {{ field }} input is required
                  </p>
                </div>
                <p v-if="payrollError">
                  An error occurred while trying load payroll details.
                </p>
              </div>

              <div
                class="payroll__setting--container-btn"
                v-if="!componentLoader"
              >
                <div
                  class="payroll__setting--container-btn-submit"
                  v-if="!loading"
                  @click="createEmployee()"
                >
                  Submit
                </div>
                <div
                  class="payroll__setting--container-btn-submit"
                  v-if="loading"
                >
                  <WhiteLoader />
                </div>
                <div class="payroll__setting--container-btn-skip">
                  <span @click="skipForm">Skip</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PayrollHeader from "../../partials/payrollHeader";
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";
import InputLoader from "../../partials/input-loader";

export default {
  name: "onboardform",
  components: {
    PayrollHeader,
    WhiteLoader,
    InputLoader,
  },

  data() {
    return {
      newEmployee: {
        firstname: "",
        lastname: "",
        staff_number: "",
        email: "",
        phone: "",
        gender: "",
        address: "",
        country: "",
        state: "",
        city: "",
      },

      compensation: {},
      deductible: {},

      serverErrors: null,

      countryData: "",
      country: false,
      stateData: "",
      state: false,
      cityData: "",
      city: false,

      loading: false,
      Loader: false,

      emptyFields: [],
      numberValidationFields: [],
      emailError: false,

      employmentLevels: [],

      dataFetchError: false,
      dataSaveError: "",
      compensationComponents: [],
      deductibleComponents: [],
      componentLoader: true,
      payrollError: false,
    };
  },

  computed: {
    companyId() {
      let user = this.$store.getters.currentAuthUser;
      return user.employees.company_id;
    },
  },

  created() {
    this.getCountryOnLoad();
    this.getUser();
    this.getPayrollComponents();
  },

  methods: {
    generateStaffId(email) {
      // TODO:
      this.Loader = true;
      this.$http
        .post(types.GET_STAFF_ID_API, {
          company_email: email,
        })
        .then((resp) => {
          this.newEmployee.staff_number = resp.data.data.id;
          this.Loader = false;
        })
        .catch((err) => {
          this.Loader = true;
        });
    },
    getUser() {
      let user = this.$store.getters.currentAuthUser;
      this.newEmployee.firstname = user.firstname;
      this.newEmployee.lastname = user.lastname;
      this.newEmployee.email = user.email;
      this.newEmployee.phone = user.phone;
      this.newEmployee.gender = user.gender;
      this.newEmployee.address = user.address;
    },
    getPayrollComponents() {
      this.$http
        .get(types.GET_PAYROLL_COMPONENTS_API)
        .then((resp) => {
          for (let index of resp.data.data) {
            if (index.type === "Compensation") {
              this.compensationComponents.push(index);
            }

            if (index.type === "Deductible") {
              this.deductibleComponents.push(index);
            }
          }
          this.componentLoader = false;
        })
        .catch((err) => {
          this.payrollError = true;
          this.componentLoader = true;
        });
    },
    skipForm() {
      this.$router.push("/dashboard");
    },
    createEmployee() {
      this.serverErrors = null;
      this.dataSaveError = "";

      if (!this.validate()) {
        return;
      }

      const compensations = [];
      const deductibles = [];

      for (let index of this.compensationComponents) {
        if (!this.compensation[index.name]) {
          this.compensation[index.name] = "0";
        }
      }
      for (let index of this.deductibleComponents) {
        if (!this.deductible[index.name]) {
          this.deductible[index.name] = "0";
        }
      }
      for (let index of this.compensationComponents) {
        for (let key in this.compensation) {
          if (key === index.name) {
            compensations.push({
              component_id: index.id,
              amount: this.compensation[key]
                ? parseFloat(this.compensation[key].replace(/,/g, ""))
                : 0,
            });
          }
        }
      }
      for (let index of this.deductibleComponents) {
        for (let key in this.deductible) {
          if (key === index.name) {
            deductibles.push({
              component_id: index.id,
              amount: this.deductible[key]
                ? parseFloat(this.deductible[key].replace(/,/g, ""))
                : 0,
            });
          }
        }
      }

      const newEmployee = {
        ...this.newEmployee,
        compensations: [...compensations],
        deductibles: [...deductibles],
      };

      this.loading = true;

      this.$http
        .put(`${types.UPDATE_ADMIN_ACCOUNT}`, newEmployee)
        .then(() => {
          this.$router.push("/dashboard");
        })
        .catch((err) => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },

    validate() {
      let updateData = this.newEmployee;
      this.emptyFields = [];
      this.emailError = false;
      this.numberValidationFields = [];

      let flag = true;

      for (var key in updateData) {
        if (typeof updateData[key] === "string") {
          const value = updateData[key].trim();

          if (!value) {
            flag = false;
            this.emptyFields.push(key);
          }

          const expression = /\S+@\S+\.\S+/;

          if (key === "password" && value.length < 8) {
            this.passwordLengthError = true;
            flag = false;
          }

          if (key == "email" && !expression.test(value)) {
            this.emailError = true;
            flag = false;
          }

          updateData[key] = value;
        }
      }

      return flag;
    },

    
    isValidNumber(str) {
      let num = Number(str);
      return !isNaN(num) && str.trim() !== "";
    },

    manualAmountSplit(stringAmount) {
      let split = stringAmount.split(".");
      let nairaPart = split[0];
      let koboPart = split[1];

      return (
        nairaPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + "." + koboPart
      );
    },

    formatAmountStructure(amount) {
      let stringAmount = amount.toString();

      return stringAmount.includes(".")
        ? this.manualAmountSplit(stringAmount)
        : stringAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    formatAmount(name, key) {

      if (name === "compensations") {
        let amount = this.compensation[key];

        if (!amount) {
          return;
        }

        if (amount.startsWith("0")) {
          amount = amount.substring(1);
        }

        if (amount.includes(".")) {
          let split = amount.split(".");

          if (split[1].length > 4) {
            this.compensation[key] = amount.substring(
              0,
              amount.length - 1
            );

            return;
          }
        }

        // Remove commas from the amount
        amount = amount.replace(/,/g, "");

        // Check if the amount is a valid number
        this.compensation[key] = this.isValidNumber(amount)
          ? // If it's a valid number, format it using the formatAmountStructure function
          this.formatAmountStructure(amount)
          : // If it's not a valid number, format it manually
          amount
            .substring(0, amount.length - 1)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }

      if (name === "deductibles") {
        let amount = this.deductible[key];


        if (!amount) {
          return;
        }

        if (amount.startsWith("0")) {
          amount = amount.substring(1);
        }

        if (amount.includes(".")) {
          let split = amount.split(".");

          if (split[1].length > 4) {
            this.deductible[key] = amount.substring(
              0,
              amount.length - 1
            );

            return;
          }
        }

        amount = amount.replace(/,/g, "");

        this.deductible[key] = this.isValidNumber(amount) ?
          this.formatAmountStructure(amount) :
          amount
            .substring(0, amount.length - 1)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },

    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },

    getState() {
      this.state = false;
      this.city = false;

      this.$http
        .get(`${types.STATE_API}/${this.newEmployee.country}`)
        .then((resp) => {
          if (this.isJson(resp.data.data)) {
            this.stateData = JSON.parse(resp.data.data);
          } else {
            this.stateData = resp.data.data;
          }
          this.state = true;
        });
    },

    getCountryOnLoad() {
      this.$http.get(types.COUNTRY_API).then((resp) => {
        if (this.isJson(resp.data.data)) {
          this.countryData = JSON.parse(resp.data.data);
        } else {
          this.countryData = resp.data.data;
        }

        if (this.countryData) {
          this.country = true;

          this.$http
            .get(`${types.STATE_API}/${this.countryData[0].id}`)
            .then((resp) => {
              if (this.isJson(resp.data.data)) {
                this.stateData = JSON.parse(resp.data.data);
              } else {
                this.stateData = resp.data.data;
              }
              this.state = true;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css);

div.content {
  padding-top: 35px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #fcfcfc;

  .data-fetch-error {
    margin-left: 17px;
    margin-top: 10px;
    text-align: center;
    color: red;
    font-size: 12px;
    font-style: italic;

    p {
      margin: 0;
    }

    p::first-letter {
      text-transform: uppercase;
    }
  }

  .payroll__setting {
    padding-bottom: 150px;
    overflow: hidden;
    max-width: 800px;
    margin: auto;

    > span {
      > a {
        color: #000;
        font-size: 12px;
        text-decoration: none;
      }
    }

    > p {
      font-size: 25px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    > div {
      overflow: hidden;
      margin-bottom: 20px;

      > .payroll__setting--nav {
        width: 300px;
        margin: auto;
        overflow: hidden;

        > .payroll__setting--nav-first {
          width: 40px;
          float: left;

          > div {
            width: 40px;
            height: 40px;
            border: solid 2px #5099de;
            border-radius: 60px;
            background-color: #5099de;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            color: #fff;
          }

          > p {
            font-size: 10px;
            font-weight: 300;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.3;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 5px;
          }
        }

        > .payroll__setting--nav-line {
          width: calc(100% - 80px);
          height: 2px;
          border: solid 1px #5099de;
          float: left;
          margin-top: 20px;
        }

        > .payroll__setting--nav-last {
          width: 40px;
          float: left;

          > div {
            width: 40px;
            height: 40px;
            border: solid 2px #5099de;
            border-radius: 60px;
            background-color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            color: #5099de;
          }

          > p {
            font-size: 10px;
            font-weight: 300;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.3;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 5px;
          }
        }
      }

      > .payroll__setting--desc {
        width: 250px;
        margin: auto;

        > div {
          width: 40px;
          margin: auto;
        }

        > p {
          font-size: 20px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          margin-top: 20px;
        }
      }

      .payroll__setting--container {
        > div {
          border: solid 0.5px #f3f3f3;
          background-color: #ffffff;
          max-width: 1000px;
          margin: auto;
          padding: 20px;

          > p {
            font-size: 14px;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.33;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
            font-weight: 600;
            margin-top: 50px;
          }

          .payroll__setting--container-input {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            align-content: center;

            > .payroll__setting--container-input-half {
              width: 45%;
              margin-bottom: 20px;

              > label {
                font-size: 12px;
                font-weight: 300;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.33;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                font-weight: 600;
              }

              > input {
                width: 100%;
                height: 40px;
                border: solid 1px #ccc;
                background-color: #ffffff;
                outline: 0;
                padding: 0 5px;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
              }

              > select {
                width: 100%;
                height: 40px;
                border: solid 1px #ccc;
                background-color: #ffffff;
                outline: 0;
                padding: 0 5px;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
              }

              > .payroll__setting--container-input-small {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                align-content: center;

                > .payroll__setting--container-input-small-gender {
                  width: 30%;

                  > label {
                    font-size: 12px;
                    font-weight: 300;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.33;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                    font-weight: 600;
                  }

                  > input {
                    width: 100%;
                    height: 40px;
                    border: solid 1px #ccc;
                    background-color: #ffffff;
                    outline: 0;
                    padding: 0 5px;
                    font-size: 12px;
                    font-style: normal;
                    font-stretch: normal;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                  }

                  > select {
                    width: 100%;
                    height: 40px;
                    border: solid 1px #ccc;
                    background-color: #ffffff;
                    outline: 0;
                    padding: 0 5px;
                    font-size: 12px;
                    font-style: normal;
                    font-stretch: normal;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                  }
                }

                > .payroll__setting--container-input-small-phone {
                  width: 65%;

                  > label {
                    font-size: 12px;
                    font-weight: 300;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.33;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                    font-weight: 600;
                  }

                  > input {
                    width: 100%;
                    height: 40px;
                    border: solid 1px #ccc;
                    background-color: #ffffff;
                    outline: 0;
                    padding: 0 5px;
                    font-size: 12px;
                    font-style: normal;
                    font-stretch: normal;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                  }

                  > select {
                    width: 100%;
                    height: 40px;
                    border: solid 1px #ccc;
                    background-color: #ffffff;
                    outline: 0;
                    padding: 0 5px;
                    font-size: 12px;
                    font-style: normal;
                    font-stretch: normal;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                  }
                }
              }
            }

            > .payroll__setting--container-input-amount {
              width: 45%;
              margin-bottom: 20px;

              > label {
                font-size: 12px;
                font-weight: 300;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.33;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                font-weight: 600;
              }

              > div {
                width: 100%;
                height: 40px;
                border: solid 1px #ccc;
                background-color: #ffffff;
                overflow: hidden;
                position: relative;

                > input {
                  width: 100%;
                  height: 100%;
                  border: 0;
                  outline: 0;
                  padding: 0 5px 0 45px;
                  font-size: 12px;
                  font-style: normal;
                  font-stretch: normal;
                  letter-spacing: normal;
                  text-align: left;
                  color: #000000;
                }

                > div {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 40px;
                  height: 40px;
                  background: #ddd;
                  border-right: #ccc;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: center;
                  align-content: center;
                }
              }
            }

            @media (max-width: 500px) {
              > .payroll__setting--container-input-half {
                width: 100%;
              }

              > .payroll__setting--container-input-amount {
                width: 100%;
              }
            }
          }

          > .payroll__setting--container-errors {
            margin: 10px 0;

            p {
              margin-bottom: 0;
              text-align: center;
              color: red;
              font-size: 0.938vw;
              font-style: italic;
            }
          }

          > .payroll__setting--container-loader {
            margin-left: 17px;
            margin-top: 10px;
            text-align: center;
            color: red;
            font-size: 12px;
            font-style: italic;
          }

          > .payroll__setting--container-btn {
            width: 200px;
            margin: auto;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;

            > .payroll__setting--container-btn-submit {
              width: 50%;
              height: 40px;
              border-radius: 2px;
              background-color: #5099de;
              font-size: 10px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: left;
              color: #ffffff;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              cursor: pointer;
            }

            > .payroll__setting--container-btn-skip {
              width: 50%;
              font-size: 12px;
              font-weight: 300;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.27;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              align-items: center;
              justify-content: center;
              align-content: center;

              > span {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  #newEmployeeform {
    margin-bottom: 100px;
  }

  input,
  input:focus {
    outline: none;
    box-shadow: none !important;
    border: solid 1px #c7c7c7;
  }
  input {
    border-radius: 0;
  }

  .icon-input {
    display: inline-flex;
    border: 1px solid #ccc;
    overflow: hidden;
    span {
      padding-right: 7px;
      width: 20px;
    }
    .input {
      border: 0;
      padding: 0.5rem 0.5rem 0.5rem 0;
      flex: 1;
    }
  }

  .section {
    margin-top: 30px;
  }

  .submit-btn {
    margin-top: 10px;
    margin-bottom: 26px;
  }

  .submit-btn > button {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #5099de;
    height: 55px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.938vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  .submit-btn > div {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #5099de;
    height: 55px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.938vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    padding-top: 15px;
  }

  .company__setting--basic-input {
    // width: 32.083vw;
    border-radius: 1px;
    height: 38px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    overflow: hidden;
    position: relative;

    @media (max-width: 1400px) {
      height: 38px;
    }

    > input {
      height: 38px;
      background-color: #ffffff;
      border: 0;
      outline: 0;
      padding: 0 5px;
      font-size: 1.25vw;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #707070;

      @media (max-width: 1400px) {
        height: 38px;
      }
    }

    > select {
      height: 38px;
      background-color: transparent;
      border: 0;
      outline: 0;
      padding: 0 10px;
      font-size: 1.25vw;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #707070;
      -moz-appearance: none;
      -webkit-appearance: none;
      position: relative;
      z-index: 2;

      ::-ms-expand {
        display: none;
      }

      @media (max-width: 1400px) {
        height: 38px;
      }
    }

    > div {
      position: absolute;
      top: 0;
      right: 0;
      width: 30px;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }

  .company__setting--basic-input-loader {
    // width: 32.083vw;
    border-radius: 1px;
    height: 38px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    overflow: hidden;

    @media (max-width: 1400px) {
      height: 38px;
    }
  }

  .error {
    margin-top: 10px;
    color: red;
    font-size: 0.938vw;
    font-style: italic;
    p {
      margin-bottom: 0;
      text-align: center;
    }
  }

  .user {
    width: 80px;
    height: auto;
    margin: auto auto;
    object-fit: contain;
  }
  .adduser {
    margin: auto auto;
    height: 50px;
    font-family: Nunito;
    font-size: 20px;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.07;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    margin-top: 25px;
  }
  .employee-entry-form {
    max-width: 800px;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding: 30px 40px 40px 50px;
    margin: auto auto;
    .form-row {
      margin-top: 20px;
    }
    ::placeholder {
      color: #777777;
      opacity: 0.5;
    }
    .text-primary {
      color: #5099de !important;
    }
    .group12 {
      width: 12px;
      object-fit: contain;
    }
    .span {
      padding: 35px 0px 0px 2px;
    }
    .benefit12 {
      color: #f49d90;
    }
    .endbutton {
      width: 300px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-content: center;

      .savebutton {
        width: 45%;
        height: 40px;
        background-color: #5099de;
        border-color: #5099de;
        font-size: 14px;
        text-align: center;
        color: #fff;
        padding-top: 10px;
        border-radius: 3px;
      }

      .skipbutton {
        width: 45%;
        height: 40px;
        font-size: 14px;
        background-color: #ec1111;
        color: #fff;
        font-style: italic;
        border-radius: 3px;
        cursor: pointer;
        text-align: center;
        padding-top: 10px;
      }
    }
  }

  .custom-select__input {
    border-radius: 1px;
    height: 38px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    overflow: hidden;
    position: relative;

    > select {
      height: 38px;
      background-color: transparent;
      border: 0;
      outline: 0;
      padding: 0 10px;
      text-align: left;
      -moz-appearance: none;
      -webkit-appearance: none;
      position: relative;
      z-index: 2;
      font-size: 12px;
      line-height: 1.67;
      color: #777777;

      ::-ms-expand {
        display: none;
      }
    }

    > div {
      position: absolute;
      color: #777777;
      top: 0;
      right: 0;
      width: 30px;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }

  .text-align-end {
    text-align: end;
  }
}
</style>
